import { APISlideAttributes, ViewIds } from '@ardoq/api-types';
import { slideOperations } from 'streams/slides/slideOperations';
import {
  type MetaInfo,
  MetaInfoViewStatus,
} from 'streams/views/mainContent/types';

export const isDiscontinuedView = (
  deprecatedViews: MetaInfo[],
  viewId: ViewIds | undefined
): boolean =>
  deprecatedViews.some(
    ({ id, viewStatus }) =>
      id === viewId && viewStatus === MetaInfoViewStatus.DISCONTINUED
  );

export const isDiscontinuedSlide = (
  slide: APISlideAttributes | undefined,
  deprecatedViews: MetaInfo[]
): boolean =>
  isDiscontinuedView(
    deprecatedViews,
    slide && slideOperations.getSlideViewId(slide)
  );
